import { useMemo } from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MachineInventoryTable from "layouts/machine/MachineInventoryTable";
import machineTableData from "layouts/machine/data/machineTableData";
import groupAvailableMachines from "layouts/machine/groupAvailableMachines";

export default function AvailableMachineGroups({ machines, onEdit, isLoading }) {
  const groups = useMemo(() => groupAvailableMachines(machines), [machines]);

  if (groups.length === 0) {
    return isLoading ? null : (
      <MDBox px={3} py={2}>
        <MDTypography variant="button" color="secondary">
          Sin máquinas disponibles
        </MDTypography>
      </MDBox>
    );
  }

  return groups.map((group) => (
    <MDBox key={group.key} pb={3}>
      <MachineInventoryTable
        machines={group.machines}
        makeTable={(listed) =>
          machineTableData({
            machinesDetails: listed,
            onEdit,
            hideDelete: true,
            hideTypeColumn: true,
          })
        }
        expectedLocalType="Depósito"
        tableName={`máquinas disponibles de ${group.title}`}
        groupTitle={group.title}
        isLoading={isLoading}
      />
    </MDBox>
  ));
}

AvailableMachineGroups.propTypes = {
  machines: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
